//src/pages/PainelCliente/RegrasPrograma.js

import {
  ShieldCheck,
  FileText,
  CreditCard,
  Gift,
  Truck,
  Wallet,
  Trophy,
  AlertTriangle,
  LockKeyhole,
  HelpCircle,
} from "lucide-react";

import "./RegrasPrograma.css";

export default function RegrasPrograma() {
  return (
    <main className="tik-regras-page">
      <section className="tik-regras-container">
        <header className="tik-regras-hero">
          <div className="tik-regras-badge">
            <ShieldCheck size={16} />
            Programa Oficial Tikpontos
          </div>

          <h1>Regulamento do Programa de Pontos Tikpontos</h1>

          <p>
            Ao participar do programa, o operador declara que leu, compreendeu e
            aceita integralmente as regras descritas neste regulamento.
          </p>
        </header>

        <div className="tik-regras-content">
          <section className="tik-regras-section">
            <div className="tik-regras-section-title">
              <Trophy size={20} />
              <h2>1. Objetivo do Programa</h2>
            </div>
            <p>
              O Tikpontos é um programa promocional desenvolvido pela Tikpag com
              o objetivo de incentivar operadores, colaboradores e parceiros
              comerciais a promoverem os serviços da plataforma Tikpag junto a
              seus clientes, especialmente operações realizadas via cartão de
              crédito.
            </p>
            <p>
              As operações aprovadas poderão gerar pontos promocionais chamados
              Tikpontos, que poderão ser utilizados para resgate de produtos,
              participação em campanhas especiais e demais benefícios
              disponibilizados pela plataforma.
            </p>
          </section>

          <section className="tik-regras-section">
            <div className="tik-regras-section-title">
              <ShieldCheck size={20} />
              <h2>2. Participação no Programa</h2>
            </div>
            <p>Poderão participar do programa:</p>
            <ul>
              <li>colaboradores vinculados a empresas participantes da Tikpag;</li>
              <li>usuários devidamente cadastrados na plataforma Tikpontos;</li>
              <li>participantes com conta ativa e regular.</li>
            </ul>
            <p>
              A participação da empresa no programa é condição obrigatória para
              acúmulo de pontos.
            </p>
            <p>Caso a empresa deixe de participar do programa:</p>
            <ul>
              <li>novos pontos deixarão de ser gerados;</li>
              <li>
                os pontos já adquiridos permanecerão válidos até sua data de
                expiração;
              </li>
              <li>
                o participante poderá utilizar os pontos existentes dentro do
                prazo de vigência, observadas as demais regras deste regulamento.
              </li>
            </ul>
          </section>

          <section className="tik-regras-section">
            <div className="tik-regras-section-title">
              <CreditCard size={20} />
              <h2>3. Regras para Geração de Pontos</h2>
            </div>
            <p>Serão consideradas elegíveis apenas operações:</p>
            <ul>
              <li>aprovadas pela Tikpag;</li>
              <li>realizadas utilizando cartão de crédito;</li>
              <li>corretamente registradas na plataforma;</li>
              <li>vinculadas ao participante responsável pela operação.</li>
            </ul>
            <p>Não geram pontuação:</p>
            <ul>
              <li>operações via PIX;</li>
              <li>boleto;</li>
              <li>cartão de débito;</li>
              <li>operações canceladas;</li>
              <li>operações negadas;</li>
              <li>operações suspeitas de fraude;</li>
              <li>operações registradas com informações incorretas.</li>
            </ul>
          </section>

          <section className="tik-regras-section tik-regras-highlight">
            <div className="tik-regras-section-title">
              <AlertTriangle size={20} />
              <h2>4. Prazo Máximo para Cadastro de Operações</h2>
            </div>
            <p>Para garantir integridade e rastreabilidade das informações:</p>
            <ul>
              <li>
                operações do Tikpontos somente poderão ser cadastradas em até{" "}
                <strong>60 dias corridos</strong> após a data da operação
                aprovada pela Tikpag;
              </li>
              <li>
                operações do programa Pix Premiado somente poderão ser
                cadastradas em até <strong>30 dias corridos</strong> após a data
                da operação aprovada.
              </li>
            </ul>
            <p>
              Operações fora desses prazos poderão ser automaticamente rejeitadas
              pelo sistema.
            </p>
          </section>

          <section className="tik-regras-section">
            <div className="tik-regras-section-title">
              <Wallet size={20} />
              <h2>5. Cálculo da Pontuação</h2>
            </div>
            <p>
              Os pontos são calculados com base no valor principal da operação,
              desconsiderando juros, taxas e encargos.
            </p>
            <ul>
              <li>
                operações em 1x ou 2x: <strong>0,20 ponto por real</strong>;
              </li>
              <li>
                operações em 3x ou mais: <strong>1 ponto por real</strong>.
              </li>
            </ul>
            <p>
              O cálculo considera exclusivamente o valor principal aprovado pela
              Tikpag.
            </p>
            <p>
              A Tikpag poderá revisar, ajustar ou rejeitar operações caso sejam
              identificadas inconsistências nos dados informados.
            </p>
          </section>

          <section className="tik-regras-section">
            <div className="tik-regras-section-title">
              <FileText size={20} />
              <h2>6. Validade dos Pontos</h2>
            </div>
            <p>
              Os Tikpontos possuem validade de{" "}
              <strong>12 meses contados da data de crédito</strong>.
            </p>
            <p>
              Pontos expirados serão automaticamente removidos do saldo do
              participante.
            </p>
          </section>

          <section className="tik-regras-section">
            <div className="tik-regras-section-title">
              <Wallet size={20} />
              <h2>7. Consulta de Saldo e Histórico</h2>
            </div>
            <p>O participante poderá acompanhar:</p>
            <ul>
              <li>saldo disponível;</li>
              <li>pontos reservados;</li>
              <li>histórico de créditos;</li>
              <li>histórico de resgates;</li>
              <li>campanhas participadas;</li>
              <li>status de pedidos.</li>
            </ul>
            <p>
              As informações estarão disponíveis na área autenticada da
              plataforma.
            </p>
          </section>

          <section className="tik-regras-section">
            <div className="tik-regras-section-title">
              <Gift size={20} />
              <h2>8. Resgates e Reserva de Pontos</h2>
            </div>
            <p>Ao solicitar um resgate:</p>
            <ul>
              <li>os pontos correspondentes poderão ficar temporariamente reservados;</li>
              <li>o pedido ficará sujeito à análise e aprovação da Tikpag;</li>
              <li>após aprovação, os pontos serão debitados definitivamente.</li>
            </ul>
            <p>
              Caso o resgate seja rejeitado, os pontos reservados poderão retornar
              ao saldo do participante.
            </p>
            <p>Após aprovação do resgate:</p>
            <ul>
              <li>não será permitido cancelamento;</li>
              <li>não haverá estorno de pontos;</li>
              <li>o pedido seguirá para fluxo logístico e expedição.</li>
            </ul>
          </section>

          <section className="tik-regras-section">
            <div className="tik-regras-section-title">
              <Truck size={20} />
              <h2>9. Entrega de Prêmios</h2>
            </div>
            <p>Os prêmios:</p>
            <ul>
              <li>poderão ser entregues exclusivamente no endereço da empresa vinculada ao participante;</li>
              <li>não poderão ter endereço alterado após aprovação;</li>
              <li>poderão possuir prazo de entrega entre 3 e 90 dias.</li>
            </ul>
            <p>A Tikpag poderá:</p>
            <ul>
              <li>substituir produtos descontinuados;</li>
              <li>alterar fornecedores;</li>
              <li>substituir itens por equivalentes de valor igual ou superior.</li>
            </ul>
            <p>As imagens exibidas possuem caráter meramente ilustrativo.</p>
          </section>

          <section className="tik-regras-section">
            <div className="tik-regras-section-title">
              <Wallet size={20} />
              <h2>10. Frete e Custos</h2>
            </div>
            <p>O frete poderá ser cobrado em pontos conforme:</p>
            <ul>
              <li>peso;</li>
              <li>distância;</li>
              <li>volume;</li>
              <li>regras logísticas vigentes.</li>
            </ul>
            <p>Os custos serão exibidos antes da confirmação do resgate.</p>
            <p>Não será permitido:</p>
            <ul>
              <li>complementar valores em dinheiro;</li>
              <li>pagamentos externos;</li>
              <li>transferências;</li>
              <li>cobranças realizadas por colaboradores da Tikpag.</li>
            </ul>
          </section>

          <section className="tik-regras-section">
            <div className="tik-regras-section-title">
              <Trophy size={20} />
              <h2>11. Campanhas Promocionais</h2>
            </div>
            <p>A Tikpag poderá criar:</p>
            <ul>
              <li>campanhas promocionais;</li>
              <li>desafios;</li>
              <li>rankings;</li>
              <li>eventos;</li>
              <li>ações temporárias.</li>
            </ul>
            <p>As campanhas poderão possuir:</p>
            <ul>
              <li>metas específicas;</li>
              <li>validade própria;</li>
              <li>premiações independentes;</li>
              <li>regras adicionais.</li>
            </ul>
            <p>
              Os pontos contabilizados em campanhas passam a valer somente após a
              inscrição do participante, sem retroatividade.
            </p>
            <p>
              Caso o participante abandone e retorne à campanha, a contagem poderá
              reiniciar do zero, conforme regras da ação vigente.
            </p>
          </section>

          <section className="tik-regras-section">
            <div className="tik-regras-section-title">
              <CreditCard size={20} />
              <h2>12. Pix Premiado</h2>
            </div>
            <p>
              A Tikpag poderá disponibilizar campanhas específicas vinculadas ao
              programa Pix Premiado.
            </p>
            <p>As regras poderão incluir:</p>
            <ul>
              <li>valor mínimo da operação;</li>
              <li>quantidade mínima de parcelas;</li>
              <li>limite temporal;</li>
              <li>aprovação manual;</li>
              <li>disponibilidade por empresa participante.</li>
            </ul>
            <p>As regras específicas poderão variar conforme campanhas vigentes.</p>
          </section>

          <section className="tik-regras-section">
            <div className="tik-regras-section-title">
              <LockKeyhole size={20} />
              <h2>13. Titularidade e Intransferibilidade</h2>
            </div>
            <p>Os pontos:</p>
            <ul>
              <li>pertencem exclusivamente ao participante;</li>
              <li>são pessoais e intransferíveis;</li>
              <li>não possuem valor monetário;</li>
              <li>não podem ser convertidos em dinheiro.</li>
            </ul>
            <p>
              A empresa vinculada não poderá solicitar transferência ou apropriação
              dos pontos do participante.
            </p>
            <p>
              Caso o participante deixe de possuir vínculo com a empresa cadastrada,
              poderá perder o direito de utilização dos pontos e poderá ter acesso
              ao programa encerrado conforme regras internas da Tikpag.
            </p>
          </section>

          <section className="tik-regras-section tik-regras-highlight">
            <div className="tik-regras-section-title">
              <ShieldCheck size={20} />
              <h2>14. Segurança e Compliance</h2>
            </div>
            <p>A Tikpag poderá:</p>
            <ul>
              <li>bloquear contas;</li>
              <li>rejeitar operações;</li>
              <li>cancelar pontuações;</li>
              <li>suspender participantes.</li>
            </ul>
            <p>Sempre que identificar:</p>
            <ul>
              <li>indícios de fraude;</li>
              <li>manipulação de operações;</li>
              <li>inconsistências cadastrais;</li>
              <li>utilização indevida do programa;</li>
              <li>tentativa de obtenção irregular de benefícios.</li>
            </ul>
          </section>

          <section className="tik-regras-section">
            <div className="tik-regras-section-title">
              <FileText size={20} />
              <h2>15. Disposições Gerais</h2>
            </div>
            <p>O programa Tikpontos:</p>
            <ul>
              <li>possui caráter promocional e gratuito;</li>
              <li>não constitui obrigação permanente;</li>
              <li>poderá ser alterado, pausado ou encerrado a qualquer momento pela Tikpag.</li>
            </ul>
            <p>A participação implica:</p>
            <ul>
              <li>ciência;</li>
              <li>concordância integral;</li>
              <li>aceitação deste regulamento.</li>
            </ul>
            <p>As alterações poderão ser comunicadas:</p>
            <ul>
              <li>pela plataforma;</li>
              <li>por e-mail;</li>
              <li>ou pelos canais oficiais da Tikpag.</li>
            </ul>
          </section>

          <section className="tik-regras-section">
            <div className="tik-regras-section-title">
              <HelpCircle size={20} />
              <h2>16. Atendimento</h2>
            </div>
            <p>
              Em caso de dúvidas, o participante poderá entrar em contato pelos
              canais oficiais disponíveis na plataforma.
            </p>
            <p className="tik-regras-slogan">
              Tikpag. Sua conta. Seu jeito. Seu prêmio.
            </p>
          </section>
        </div>
      </section>
    </main>
  );
}